var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 21590 27940",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_866096352"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M13136 25997l2781 -3245c0,497 0,995 0,1493 0,547 51,1004 -201,1318 -335,417 -561,434 -1061,434 -506,0 -1013,0 -1519,0zm-3361 0l0 0 2540 -11 2933 -3441 -2350 17 -3123 3435zm-3207 0l0 0 3292 -3430 2220 -22 -3271 3453 -2241 -1zm-3091 0l0 0 2228 -13 3284 -3439 -2010 -1 -3502 3453zm-953 0l0 0c-772,0 -1181,-1142 -915,-1550l3568 -3498c0,357 161,716 308,927 187,267 429,412 696,541l-3657 3580zm3271 -5100l0 0c0,151 38,314 87,428 160,367 535,602 943,602l9066 0c575,0 1031,-439 1031,-978l0 -10509c-914,0 -2160,-687 -2712,-1435 -538,-730 -762,-1240 -840,-2147 -8,-82 6,-127 -80,-127l-6413 0c-600,0 -1082,463 -1082,1004l0 13162zm-4224 2704l0 0 8 -2017 3598 -3391 1 1889 -3607 3519zm0 -2910l0 0 3612 -3385 -6 -2024 -3596 3426 -10 1983zm0 -2859l0 0 -6 -2111 3612 -3349 -5 2026 -3601 3434zm0 -2962l0 0 3622 -3372 -16 -2063 -3606 3220 0 2215zm0 -3039l0 0c0,-176 -22,-1732 12,-1817l2229 -1892 1365 0 0 461 -3606 3248zm0 -2653l0 0 1236 -1056c-240,0 -368,-18 -545,47 -248,93 -495,301 -593,541 -55,134 -98,265 -98,468zm12414 -2473l0 0c0,-864 189,-1509 732,-2204 526,-557 940,-904 1751,-1108 655,-166 1477,-107 2078,194 730,365 852,474 1344,1077 399,489 612,1329 612,1990 0,1185 -825,2418 -1924,2892 -270,116 -828,285 -1119,298 -631,29 -1183,-123 -1748,-383 -170,-78 -579,-386 -715,-521 -593,-587 -1011,-1338 -1011,-2235zm-592 -592l0 0 -6516 0c-662,0 -1151,319 -1464,803 -69,107 -198,412 -210,562 -586,0 -2493,-36 -2918,44 -188,36 -246,58 -403,138 -34,17 -95,49 -135,72 -496,280 -794,847 -794,1446l0 15814c0,448 170,826 483,1140 261,262 624,483 1139,483l12363 0c748,0 1410,-579 1554,-1306 45,-229 18,-2436 18,-2867 371,-196 434,-206 713,-548 181,-222 317,-576 317,-971l0 -10483c1087,0 2323,-714 2874,-1633 885,-1477 1032,-3050 -26,-4512 -284,-392 -564,-641 -949,-931 -301,-227 -923,-492 -1322,-584 -1008,-231 -2152,-33 -2963,510 -853,571 -1761,1740 -1761,2823z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M16020 7375l-43 -597c-12,-355 -602,-366 -560,83l102 1074c31,344 121,484 477,466l1262 -64c134,-7 205,-130 205,-318 0,-135 -139,-244 -230,-242l-698 10 2283 -2379c122,-161 97,-331 -48,-449 -128,-104 -257,-107 -355,-8l-2395 2424z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M7006 11264c187,0 586,-470 727,-612l1365 -1365c99,-98 266,-222 309,-362 48,-154 -30,-391 -315,-391 -177,0 -482,366 -651,534l-1668 1655c-210,178 -127,541 233,541z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M6645 9384c0,287 344,470 628,139l1374 -1330c257,-256 200,-428 87,-545 -103,-105 -327,-85 -460,43l-1236 1184c-110,110 -393,329 -393,509z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M9375 8251c-49,158 170,355 361,309 149,-37 543,-447 592,-593 68,-201 -148,-413 -309,-360 -163,54 -592,475 -644,644z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M11400 7071l0 0c169,0 307,138 307,307l0 6621 4511 0c168,0 306,138 306,306l0 0c0,169 -138,307 -306,307l-4511 0 0 6621c0,168 -138,306 -307,306l0 0c-168,0 -306,-138 -306,-306l0 -6621 -4679 0c-168,0 -306,-138 -306,-307l0 0c0,-168 138,-306 306,-306l4679 0 0 -6621c0,-169 138,-307 306,-307z",
    fill: "#808080"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWindows);
export default __webpack_public_path__ + "static/media/new-windows.6b2cec8a31ba08aeaf4702c60f568b6b.svg";
export { ForwardRef as ReactComponent };